import styled from '@emotion/styled';
import {Grid} from '@mui/material';

export const SmallLogoGrid = styled(Grid)`
  background-color: ${prop => prop.theme.palette.common.white};
`;
